import { render, staticRenderFns } from "./versioned-file.vue?vue&type=template&id=72782d4e&scoped=true"
import script from "./versioned-file.vue?vue&type=script&lang=js"
export * from "./versioned-file.vue?vue&type=script&lang=js"
import style0 from "./versioned-file.vue?vue&type=style&index=0&id=72782d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72782d4e",
  null
  
)

export default component.exports